import { FullInfoResponse, PaymentFormField } from 'react-easyrocket';

export const setDefalutValue = (
  field: PaymentFormField,
  fullInfo: FullInfoResponse | undefined
) => {
  if (field.toShow && fullInfo) {
    const DATA = [
      {
        fieldName: /surname/i,
        value: fullInfo.surname
      },
      {
        fieldName: /\bname\b/g,
        value: fullInfo.name
      },
      {
        fieldName: /email/i,
        value: fullInfo.email
      },
      {
        fieldName: /phone/i,
        value: fullInfo.phone.code + fullInfo.phone.number
      },
      {
        fieldName: /city/i,
        value: fullInfo.city
      },
      {
        fieldName: /postcode|zip|client_pincode/i,
        value: fullInfo.postcode
      },
      {
        fieldName: /\baddress\b/g,
        value: fullInfo.address
      },
      {
        fieldName: /birthday/i,
        value: fullInfo.birthday
      },
      {
        fieldName: /country/i,
        value: fullInfo.country
      }
    ];

    for (let i = 0; i < DATA.length; i++) {
      if (DATA[i]?.fieldName.test(field.name)) {
        return DATA[i]?.value;
      }
    }
    return field.value;
  }
  return field.value;
};
